import styled from "styled-components";
import { ETheme } from "@/DependenciesV9";

export const ContentWrapper = styled.div<{$theme?: ETheme}>`
    width: 100%;
    height: calc(100vh - 48px);
    background: ${props => props.$theme === ETheme.Light ? "#F8F8F8" : ""};
    display: flex;
    overflow: hidden;
`

export const ContentRightWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
`

export const HeaderContentRightWrapper = styled.div`
    width: 100%;
    height: 44px;
    border-bottom: 1px solid rgb(234, 234, 234);
    display: flex;
    align-items: center;
    padding-left: 10px;
`

export const BodyContentRightWrapper = styled.div`
    width: 100%;
    height: 100%;
    border-left: 1px solid rgb(234, 234, 234);
    padding: 20px 20px 5px;
`